import { routeModifierLinkSchema } from './route-modifier-link.schema';
import { z } from 'zod/v4';

export const routeModifierInfoSchema = z.object({
  SetID: z.number(),
  name: z.string(),
  tag: z.string().nullable(),
  links: z.array(routeModifierLinkSchema),
});

export type RouteModifierInfo = z.infer<typeof routeModifierInfoSchema>;
